// Performance wrapper - disables framer-motion animations
// This significantly improves performance by removing animation overhead

import React from 'react';

// Create a simple wrapper that ignores animation props
export const motion = new Proxy({} as any, {
  get(target, prop) {
    return React.forwardRef((props: any, ref) => {
      // Filter out animation-related props
      const {
        initial,
        animate,
        exit,
        whileHover,
        whileInView,
        whileTap,
        whileFocus,
        whileDrag,
        viewport,
        transition,
        variants,
        ...restProps
      } = props;
      
      // Return the base HTML element without animations
      return React.createElement(prop as string, { ...restProps, ref });
    });
  }
});

// Export other framer-motion utilities as no-ops
export const useScroll = () => ({ scrollYProgress: { get: () => 0, on: () => () => {} } });
export const useTransform = (value: any, input: any, output: any) => ({ get: () => 0 });
export const useSpring = (value: any, config: any) => ({ get: () => 0 });
export const useInView = () => false;
export const AnimatePresence = ({ children }: any) => children;

export type Variants = any;
export type Easing = any;
